import moment from 'moment';

export const COLUMNS =[
    {
        Header      : 'Certificate No',
        accessor    : 'certificateno',
        Cell            : e=><div className="text-center"><a href={'/admin/viewcertificationstatus/'+(e.value).split("-")[0]}> {(e.value).split("-")[1]} </a></div>,
    //    Cell            : e=><div className="text-center"><a href={'/admin/viewcertificationstatus/'+(e.value).split("-")[0]}> {(e.value).split("-")[1]} </a></div>,
        // Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/surveillanceobservation/'+(e.value).split("-")[1]}> {'View'} </a></div>,

    },
    {
        Header      : 'Organization Name',
        accessor    : 'orgName',
        disableFilters:true
    },
    {
        Header      : 'Type of Certification',
        accessor    : 'typeOfCertification',
        disableFilters:true
    },
    {
        Header      : 'Original Registered Date',
        accessor    : 'dateofissue',
        Cell        : e => <div className='text-center'>{(moment(e.value).format('DD-MM-YYYY'))}</div>,
        disableFilters:true
    },
    {
        Header      : 'Current Issue Date',
        accessor    : 'initialcertdate',
        Cell        : e => <div className='text-center'>{(moment(e.value).format('DD-MM-YYYY'))}</div>,
        disableFilters:true
    },
    {
        Header      : 'Expiry Date',
        accessor    : 'expirydate',
        Cell        : e => <div className='text-center'>{(moment(e.value).format('DD-MM-YYYY'))}</div>,
        disableFilters:true
    },
    {
        Header      : 'Status',
        accessor    : 'status',
        disableFilters:true
    },
]